import React, { Component } from "react";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import Checkmark from "../../assets/images/etl-page/CheckMark-ETL.png";
import IFAircraft from "../../assets/images/etl-page/IFAircraft.png";
import AircraftBackground from "../../assets/images/main-homebackground-aircraft-image.png";
import { styled } from "@mui/material/styles";
import airOperators from "../../assets/images/etl-page/airOperators.png"

const PREFIX = "AirOperators";
const classes = {
  mainGrid: `${PREFIX}-mainGrid`,
  mainHeadingGrid: `${PREFIX}-mainHeadingGrid`,
  mainHeading: `${PREFIX}-mainHeading`,
  mainOperatorContent: `${PREFIX}-mainOperatorContent`,
  operatorContentGrid: `${PREFIX}-operatorContentGrid`,
  leftOperatorsGrid: `${PREFIX}-leftOperatorsGrid`,
  operatorTypeGridStyle: `${PREFIX}-operatorTypeGridStyle`,
  rightOperatorsGrid: `${PREFIX}-rightOperatorsGrid`,
  checkmarkGridStyle: `${PREFIX}-checkmarkGridStyle`,
  checkMarkImage: `${PREFIX}-checkMarkImage`,
  operatorTypeTextGrid: `${PREFIX}-operatorTypeTextGrid`,
  checkMarkTextStyle: `${PREFIX}-checkMarkTextStyle`,
  operatorImageGrid: `${PREFIX}-operatorImageGrid`,
  operatorImage: `${PREFIX}-operatorImage`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.mainGrid}`]: {
    marginTop: "2%",
    paddingTop: "4em",
    paddingBottom: "5em",
  },
  [`& .${classes.mainHeadingGrid}`]: {
    paddingLeft: "3em",
    paddingBottom: "3em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 0.5em",
    },
  },
  [`& .${classes.mainHeading}`]: {
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 35,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 40,
    },
  },
  [`& .${classes.mainOperatorContent}`]: {
    display: "flex",
  },
  [`& .${classes.operatorContentGrid}`]: {
    padding: "2em 0 0 7em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 0em",
    },
    [theme.breakpoints.down("sm", "md")]: {
      padding: "0 0 0 0em",
      justifyContent: "center",
    },
  },
  [`& .${classes.leftOperatorsGrid}`]: {
    paddingRight: "3rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 0em",
    },
    [theme.breakpoints.down("sm", "md")]: {
      paddingLeft: "2rem",
    },
  },
  [`& .${classes.rightOperatorsGrid}`]: {
    paddingRight: "3rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 0em",
    },
    [theme.breakpoints.down("sm", "md")]: {
      paddingTop: "2rem",
      paddingLeft: "2rem",
    },
  },
  [`& .${classes.operatorTypeGridStyle}`]: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#f0fff0",
    borderRadius: "5px",
    paddingLeft: "0.5rem",
    paddingBottom: "0.15em",
  },
  [`& .${classes.checkMarkImage}`]: {
    // checkmarkGridStyle: {},
    // : {
    width: 20, // width: 81,
    height: 20, // height: 91,
    [theme.breakpoints.down("sm")]: {
      width: 20,
      height: 20,
    },
  },
  [`& .${classes.operatorTypeTextGrid}`]: {
    marginTop: "3px",
  },
  [`& .${classes.checkMarkTextStyle}`]: {
    whiteSpace: "nowrap",
    fontFamily: "AvenirLTStd-Roman",
    color: "green",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  [`& .${classes.operatorImageGrid}`]: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {},
    borderRadius: "40px",
  },
  [`& .${classes.operatorImage}`]: {
    borderRadius: "40px",
    backgroundSize: "contain",
    width: 400, // width: 81,
    height: 400, // height: 91,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      height: 300,
      marginTop: "2em",
      borderRadius: "40px",
    },
    [theme.breakpoints.between("sm", "md")]: {
      borderRadius: "40px",
      width: 280,
      height: 280,
      marginTop: "0em",
    },
  },
}));

const AirOperators = () => {
  return (
    <div>
      <StyledGrid container className={classes.mainGrid}>
        <Grid size={{ xs: 12 }}>
          <Grid container className={classes.mainOperatorContent}>
            <Grid size={{ xs: 6 }} className={classes.operatorContentGrid}>
              <Grid container>
                <Grid
                  size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                  className={classes.leftOperatorsGrid}
                >
                  <Stack spacing={5}>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3, sm: 3, lg: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9, sm: 9, lg: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          Business
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          Private Charter
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          SPO
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                  className={classes.rightOperatorsGrid}
                >
                  <Stack spacing={5}>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3, sm: 3, md: 3, lg: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9, md: 6, lg: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          Commercial
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3, sm: 3, lg: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9, md: 9, lg: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          Cargo
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container className={classes.operatorTypeGridStyle}>
                      <Grid
                        size={{ xs: 3, md: 3, lg: 3 }}
                        className={classes.checkmarkGridStyle}
                      >
                        <img
                          alt="checkmark"
                          src={Checkmark}
                          className={classes.checkMarkImage}
                        />
                      </Grid>
                      <Grid
                        size={{ xs: 9, sm: 9, md: 9 }}
                        className={classes.operatorTypeTextGrid}
                      >
                        <Typography className={classes.checkMarkTextStyle}>
                          Rotorcraft
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1 }}></Grid>
            <Grid
              size={{ xs: 12, sm: 4, md: 4, lg: 4 }}
              className={classes.operatorImageGrid}
            >
              <img
                alt="checkmark"
                src={airOperators}
                className={classes.operatorImage}
              />
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1 }}></Grid>
          </Grid>
        </Grid>
      </StyledGrid>
    </div>
  );
};

export default AirOperators;
